export const SET_BUSINESS_ID = "SET_BUSINESS_ID";
export const SET_ROUTE = "SET_ROUTE";
export const SET_BREAD_CRUMB_PROPS = "SET_BREAD_CRUMB_PROPS";

export const DELETE_PROXY_REQUEST = "DELETE_PROXY_REQUEST";
export const DELETE_PROXY_SUCCESS = "DELETE_PROXY_SUCCESS";
export const DELETE_PROXY_FAILURE = "DELETE_PROXY_FAILURE";

export const CLEAR_ALERTS = "CLEAR_ALERTS";
